import { Box, Divider, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Checkbox from "../../../common/Checkbox";
import { filterCategories } from "../../../constants/constants";
import "./sideBar.scss";

const SideBar = ({ handleDataFilter, count }) => {
  const { t } = useTranslation();
  const [sideFilterCategories, setSideFilterCategories] = useState(
    filterCategories(t)
  );

  const handleFilter = (e) => {
    let filterString = "";
    const payload = sideFilterCategories.map((item) => {
      let idArray = e.target.id.split(",");
      if (item.category == idArray[0]) {
        let payloadDetail = item.types.map((elem) => {
          if (elem.key == idArray[1]) {
            elem.value = e.target.checked;
          }
          if (elem.value) {
            if (filterString != "") {
              filterString = filterString + ";";
            }
            filterString = filterString + elem.key;
          }
          return elem;
        });
        item.types = payloadDetail;
      } else {
        let payloadDetail = item.types.map((elem) => {
          if (elem.value) {
            if (filterString != "") {
              filterString = filterString + ";";
            }
            filterString = filterString + elem.key;
          }
          return elem;
        });
        item.types = payloadDetail;
      }
      return item;
    });
    handleDataFilter(filterString);
    setSideFilterCategories(payload);
  };
  const resetFilters = () => {
    const payload = sideFilterCategories.map((item) => {
      let payloadDetail = item.types.map((elem) => {
        elem.value = false;
        return elem;
      });
      item.types = payloadDetail;
      return item;
    });
    handleDataFilter("");
    setSideFilterCategories(payload);
  };
  return (
    <div className="filter-sidebar">
      <Box display="flex" justifyContent="space-between" padding="1rem 0">
        <Box display="flex">
          <p>{t("filters")}</p>
          <Box
            borderRadius="10px"
            width="20px"
            height="20px"
            backgroundColor="color.magentaDark2"
            marginLeft="10px"
            textAlign="center"
            color="color.white"
            fontWeight="bold"
            fontSize="14px"
          >
            {count}
          </Box>
        </Box>
        <p
          style={{ cursor: "pointer", color: "#917D9E" }}
          onClick={resetFilters}
        >
          {t("reset-filters")}{" "}
        </p>
      </Box>
      <Divider />
      {sideFilterCategories.map((elem) => {
        return (
          <div className="filter-category">
            <p>
              <b>{t(elem.category)}</b>
            </p>
            {elem?.types?.map((item) => (
              <div className="filter-options">
                <Checkbox
                  id={elem.category + "," + item.key}
                  checked={item.value}
                  onChange={handleFilter}
                />
                <Typography margin="10px 0 0 10px">
                  {t(item.translationKey)}
                </Typography>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SideBar;
